/** One hoster's IMAP endpoint, so the form fills host, port and security from a name. */
export interface ImapPreset {
	id: string;
	label: string;
	host: string;
	port: number;
	security: "tls" | "starttls";
}

/**
 * The hosters German businesses commonly sit on, with the endpoint each publishes. The list is
 * a convenience for the connect form and nothing else: a mailbox stores the host it was given,
 * and a hoster not listed here is entered by hand.
 */
export const IMAP_PRESETS: ReadonlyArray<ImapPreset> = [
	{ id: "ionos", label: "IONOS", host: "imap.ionos.de", port: 993, security: "tls" },
	{ id: "strato", label: "STRATO", host: "imap.strato.de", port: 993, security: "tls" },
	{ id: "hetzner", label: "Hetzner", host: "mail.your-server.de", port: 993, security: "tls" },
	{ id: "t-online", label: "T-Online", host: "secureimap.t-online.de", port: 993, security: "tls" },
	{ id: "gmx", label: "GMX", host: "imap.gmx.net", port: 993, security: "tls" },
	{ id: "web-de", label: "WEB.DE", host: "imap.web.de", port: 993, security: "tls" },
	{ id: "posteo", label: "Posteo", host: "posteo.de", port: 993, security: "tls" },
	{ id: "mailbox-org", label: "mailbox.org", host: "imap.mailbox.org", port: 993, security: "tls" },
	{
		id: "gmail",
		label: "Google Workspace / Gmail",
		host: "imap.gmail.com",
		port: 993,
		security: "tls",
	},
];
